// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import StepHeaderBlock from './StepHeaderBlock';
import { Whitespace, Text } from '../common';
import InputHeader from '../common/FormComponents/InputHeader';
import Input from '../common/FormComponents/InputStyle';
import ListPlaceTips from '../../components/ListPlaceTips/ListPlaceTips';
import FormNav from '../common/FormComponents/FormNav';
import { observer } from 'mobx-react';
import { allowNumericKeysOnly } from './utils';

@observer
class Price extends Component {
  static propTypes = {
    store: PropTypes.object,
    nextPage: PropTypes.func,
  };

  render() {
    const { store, nextPage } = this.props;

    const visited = store.groupsVisited.price;
    const errors = store.fieldErrors('basePrice');

    return (
      <Grid>
        <Row>
          <Col xs={12} sm={7} md={7} lg={7}>
            <StepHeaderBlock headerText="Alright now, let's set your price." />
            <Whitespace smaller />

            <InputHeader
              label="Daily Rate"
              error={
                (visited &&
                  errors &&
                  errors.length &&
                  'Price must be between 1 and 9999') ||
                ''
              }
            />
            <div className="w-100 f f-columns f-sc">
              <span className="t-lx mr-s">$ </span>
              <Input
                onChange={e => (store.basePrice = e.target.value)}
                value={store.basePrice}
                onKeyPress={allowNumericKeysOnly}
                min="1"
                max={9999}
                maxlength="4"
                required
                type="number"
              />
            </div>

            <Whitespace smaller />
            <FormNav nextPage={nextPage} store={store} />
          </Col>
          <Col>
            <ListPlaceTips
              tips={[
                {
                  title: 'Pricing',
                  tips: [
                    'If your rental requires extensive cleaning or maintenance between uses, add a few bucks to your price to cover that work.',
                    'Prices must be whole dollar amounts.',
                    'A 10% service fee will be deducted from your payout.',
                  ],
                },
              ]}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Price;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Price.js